import React from 'react';

import RulesContainer from '@totem/components/rulesEngine/report/rulesContainer';
import RulesLayout, {
  RulesExtra,
} from '@totem/components/rulesEngine/report/rulesLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const RulesPage = () => {
  return (
    <ContentLayout>
      <RulesContainer>
        <IBCard isCovered title="Rules Engine" extra={<RulesExtra />}>
          <RulesLayout />
        </IBCard>
      </RulesContainer>
    </ContentLayout>
  );
};

export default RulesPage;
